import { faPen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'src/components/design-system/Button';
import GuideMeTitleBar from 'src/components/GuideMeTitleBar';
import { errorIcon, informationIcon, warningIcon } from 'src/utils/icons';
import { hasPermission } from 'src/utils/JWT';
import { useContextSelector } from 'use-context-selector';
import { EditIconPermissions, ViewPeriodPermissions } from '../view_invoice_budget_period';
import { InvoiceContext } from './InvoiceDetailsContext';

const MatchTotals = () => {
  const title = useContextSelector(InvoiceContext, (value) => value.title);
  const mpaPermissionNumber = useContextSelector(
    InvoiceContext,
    (value) => value.mpaPermissionNumber
  );

  const isEditIconVisible = hasPermission(EditIconPermissions, mpaPermissionNumber);
  const isViewIconVisible = hasPermission(ViewPeriodPermissions, mpaPermissionNumber);
  return (
    <ul className="px-4 font-bold text-[13px]">
      <li className="list-disc font-semibold">
        Enter or review the Grand Total and {title} Date information from the {title}.
      </li>
      <li className="list-disc font-semibold">
        Enter or review Discounts, Taxes, and Shipping costs.
      </li>
      {isEditIconVisible && (
        <li className="list-disc font-semibold">
          Click on either the
          <button
            className={`inline-flex justify-center items-center ml-1 mr-1 w-4 h-4 ${'bg-info'}  rounded-full cursor-pointer focus:ring-1 focus:ring-black`}
          >
            <FontAwesomeIcon icon={faPen} color="white" size="xs" />
          </button>
          near Accounting Period label or the
          <Button color="info">Edit Periods</Button>
          present in GL Distribution Summary grid to manage multi-period assignments on the
          document.
        </li>
      )}
      {isViewIconVisible && (
        <li className="list-disc font-semibold">
          Click on either the
          <span className="-mb-1 inline-block mx-1">{informationIcon}</span>near Accounting Period
          label or the
          <Button color="info">View Periods</Button>
          present in GL Distribution Summary grid to view, switch single or multi-period assignments
          on the document.
        </li>
      )}
      {}
    </ul>
  );
};

const MatchLineItems = () => {
  const title = useContextSelector(InvoiceContext, (value) => value.title);
  return (
    <ul className="px-4 font-bold text-[13px]">
      <li className="list-disc font-semibold">
        For products not received (i.e. rejected, discontinued, or backordered), select the line(s)
        containing the missing product(s) and click on the "Zero Qty" button to reduce the Qty
        Received to "0".
      </li>
      <li className="list-disc font-semibold">
        Look for or filter for rows displaying the icon
        <span className="inline-block align-middle px-2">{warningIcon}</span>
        to review discrepancies between the PO and {title} record.
      </li>
    </ul>
  );
};

const Complete = () => {
  const title = useContextSelector(InvoiceContext, (value) => value.title);
  const type = useContextSelector(InvoiceContext, (value) => value.type);
  return (
    <ul className="px-4 font-bold text-[13px]">
      <li className="list-disc font-semibold">
        {type === 'invoice'
          ? `When the ${title} record reflects what you plan to pay, click the Complete button.`
          : `When the ${title} record reflects the expected credit value, click the Complete button.`}
      </li>
      <li className="list-disc font-semibold">
        <p className="flex items-center">
          Resolve any errors identified by this icon
          <span className="px-2">{errorIcon}</span> and save your changes.
        </p>
      </li>
    </ul>
  );
};

export const guideMeSteps = [
  {
    content: <MatchTotals />,
    title: <GuideMeTitleBar title="Match Totals" />,
  },
  {
    content: <MatchLineItems />,
    title: <GuideMeTitleBar title="Match Line Items" />,
  },
  {
    content: <Complete />,
    title: <GuideMeTitleBar title="Complete (Approve)" />,
  },
];
